import { useCallback } from 'react';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CreateMessageRequest {
  Subject: string;
  Body: string;
  SenderClientId: number; // decimal
  ProxyClientId: number; // decimal
  Priority: number; // int
  IsReply: boolean;
  RecipientClientIds: number[]; // list of decimals
}

interface CreateMessageResponse {
  messageId: number;
  success: boolean;
  message?: string;
}

const useCreateMessageApi = () => {
  const call = useCallback(async (requestBody?: CreateMessageRequest & { recipientClientIds?: string[] }): Promise<CreateMessageResponse> => {
    try {
      //console.log('useCreateMessageApi - recipientClientIds:', requestBody?.recipientClientIds); //for debug

      if (!requestBody) {
        throw new Error('Request body is required');
      }
      // Send recipientClientIds in the request body
      const response = await axiosInstance.post('Message/create', requestBody, {
        // Let axios interceptor handle authorization
      });
      return {
        messageId: response.data?.messageId || 0,
        success: true,
        message: 'Message sent successfully'
      };
    } catch (error: any) {
      console.error('Create message API error:', error);
      throw {
        success: false,
        message: error?.response?.data?.message || error?.message || 'Failed to send message',
        ...error
      };
    }
  }, []);

  const { execute, isLoading, error } = useAsync(call, false);

  return {
    createMessage: execute,
    isCreatingMessage: isLoading,
    createMessageError: error,
  };
};

export default useCreateMessageApi;